import React from 'react';
export const GraphEditorCtx = React.createContext({});
export function useGraphEditorCtx() {
    return React.useContext(GraphEditorCtx);
}
